import { AlertCircle } from 'lucide-react';

const FormFooter = () => {
  return (
    <div className="mt-6 p-4 bg-blue-chaos/20 rounded-2xl border border-blue-chaos-light">
      <div className="flex items-center space-x-3">
        <AlertCircle
          size={20}
          className="text-magical-moonlight-d3 mt-0.5 flex-shrink-0"
        />
        <div className="text-sm text-magical-moonlight-d3">
          <p>Open the registration link sent to your email/WhatsApp</p>
          <p>
            Enter your email, set your password, and sign in to your Dashboard.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
